import EventBus from '@/event-bus';

// @vue/component
export default {
  computed: {
    appVersion() {
      return !GLOBALS.ENDPOINTS.match(/production/) ? GLOBALS.VERSION_STRING.trim() : '';
    },
  },
  created() {
    EventBus.$emit('app-loaded');
  },
};
